import { isEmpty } from 'lodash';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
type Link = {
  onClick?: () => void;
  url?: string;
  type?: 'button';
};
export const getLinkTagName = (link: Link | null | undefined) => {
  if (isEmpty(link)) {
    return 'div';
  }

  return link.url ? DynamicLink : 'button';
};
export const getLinkProps = (link: Link | null | undefined): Link =>
  link?.url ? { ...link } : { ...link, type: 'button' };
